import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Retailers = () => {
  const tableRef = useRef(null);
  const [retailers, setRetailers] = useState([]);

  useEffect(() => {
    
    fetch(`${API_BASE_URL}/LoginRegistration/GetUsersByType?type=Retailers`)
      .then((response) => response.json())
      .then((data) => {
        setRetailers(data);
        data = data.map((record, index) => ({
          ...record,
          SrNo: index + 1,
        }));

        console.log("Processed Retailers Data:", data); // <-- Add this line
        

        if (tableRef.current) {
          // Destroy existing table if it exists
          if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().clear().destroy();
          }

          $(tableRef.current).DataTable({
          destroy: true,
          data: data,
          columns: [
            { data: 'SrNo', title: 'Sr No' },
            { data: 'date', title: 'Date' },
            { data: 'cmsid', title: 'CMSID' },
            { data: 'name', title: 'Name' },
            { data: 'email', title: 'Email Id' },
            { data: 'number', title: 'Phone' },
            { data: 'address', title: 'Address' },
            {
              data: null,
              title: 'AadharCard',
              render: (data, type, row) => {
                return `<button class='btn btn-sm btn-primary download-doc-btn' data-id='${row.id}' data-type='PdfAdhar'>Download</button>`;
              },
            },
            {
              data: null,
              title: 'PanCard',
              render: (data, type, row) => {
                return `<button class='btn btn-sm btn-primary download-doc-btn' data-id='${row.id}' data-type='PdfPan'>Download</button>`;
              },
            },
            {
              data: null,
              title: 'Photo',
              render: (data, type, row) => {
                return `<button class='btn btn-sm btn-primary download-doc-btn' data-id='${row.id}' data-type='Image'>Download</button>`;
              },
            },
            {
              data: null,
              title: 'Action',
              render: (data, type, row) => {
                return `<button class='btn btn-sm btn-danger delete-user-btn' data-id='${row.id}'>Delete</button>`;
              },
            },
          ],
        });

        // Event delegation for download buttons (using .off() to prevent duplicates)
        $('#productsTable tbody').off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
          const userId = $(this).data('id');
          const fileType = $(this).data('type');
          downloadPDF(userId, fileType);
        });

        // Event delegation for delete buttons (using .off() to prevent duplicates)
        $('#productsTable tbody').off('click', '.delete-user-btn').on('click', '.delete-user-btn', function () {
          const userId = $(this).data('id');
          if (window.confirm("Are you sure you want to delete this user?")) {
            deleteUser(userId);
          }
        });
         }
      });
  }, []);

  const downloadPDF = async (userId, type) => {
    try {
      const authToken = localStorage.getItem('authToken');
      const endpoint = `${API_BASE_URL}/LoginRegistration/DownloadDocument/${userId}/${type}`;

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.status}`);
      }

      const blob = await response.blob();
      const contentType = response.headers.get('Content-Type');
      const fileExtension = contentType.split('/')[1] || 'pdf';

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Document_${type}.${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Download error:', error);
    }
  };

  const deleteUser = async (userId) => {
    try {
      const authToken = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/LoginRegistration/DeleteUser/${userId}`, {
        method: 'POST', // Switched to POST to avoid 405 Method Not Allowed
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        let errorMessage = 'Failed to delete user';
        const responseText = await response.text(); // Read once as text
        try {
          const errorData = JSON.parse(responseText); // Try parsing
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch (e) {
          // If not JSON, use the raw text
          errorMessage = responseText || `Error ${response.status}: ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      alert('User deleted successfully');
      window.location.reload(); // Refresh to update the table
    } catch (error) {
      console.error('Delete error:', error);
      alert('Error deleting user: ' + error.message);
    }
  };

  return (
     <table
            ref={tableRef}
            id="productsTable"
            className="table table-bordered table-hover table-product"
            style={{ width: '100%' }}
          >
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Date</th>
                <th>CMS ID</th>
                <th>Name</th>
                <th>Email Id</th>
                <th>Phone</th>
                <th>Address</th>
                <th>AadharCard</th>
                <th>PanCard</th>
                <th>Photo</th>
                <th>Action</th>
              </tr>
            </thead>
          </table>
  );
};

export default Retailers;


// import React, { useEffect, useRef , useState} from 'react';
// import $ from 'jquery';
// import 'datatables.net-bs4';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const Retailers = () => {
//   const tableRef = useRef(null)
//   const [retailers, setRetailers] = useState([]);

//   useEffect(() => {
//     //fetch('http://localhost:5121/api/LoginRegistration/GetUsersByType?type=Retailers')
//     fetch('https://apiv2.chakran.in/api/LoginRegistration/GetUsersByType?type=Retailers')
//       .then((response) => response.json())
//       .then((data) => {
//         setRetailers(data);
//         // Add SrNo property to each record
//         data = data.map((record, index) => ({
//           ...record,
//           SrNo: index + 1 // Add auto-incrementing SrNo
//         }));
//         console.log("Raw API Data:", data);
//         if (tableRef.current) {
//           $(tableRef.current).DataTable({
//             data: data,
//             columns: [
//               { data: 'SrNo', title: 'Sr No' },
//               { data: 'date', title: 'Date' },
//               { data: 'cmsid', title: "CMSID" },
//               { data: 'name', title: 'Name' },             
//               { data: 'email', title: 'Email Id' },
//               { data: 'number', title: 'Phone' },
//               { data: 'address', title: 'Address' },
//               {
//                 data: 'adharPath',
//                 title: 'AadharCard',
//                 render: (data) => {
//                   //const downloadLink = `http://localhost:5121${data}`;
//                   const downloadLink = `https://apiv2.chakran.in${data}`;
//                   console.log('Download link:', downloadLink); // Log the URL for debugging
//                   return `<a href="${downloadLink}" download className="btn btn-primary">Download</a>`;
//                 }
//               },
//               {
//                 data: 'panPath',
//                 title: 'PanCard',
//                 render: (data) => {
//                   //const downloadLink = `http://localhost:5121${data}`;
//                   const downloadLink = `https://apiv2.chakran.in${data}`;
//                   console.log('Download link:', downloadLink); // Log the URL for debugging
//                   return `<a href="${downloadLink}" download className="btn btn-primary">Download</a>`;
//                 }
//               },
//               {
//                 data: 'photoPath',
//                 title: 'Photo',
//                 render: (data) => {
//                   //const downloadLink = `http://localhost:5121${data}`;
//                   const downloadLink = `https://apiv2.chakran.in${data}`;
//                   console.log('Download link:', downloadLink); // Log the URL for debugging
//                   return `<a href="${downloadLink}" download className="btn btn-primary">Download</a>`;
//                 }
//               }
//             ]
//           });
//         }
//       });
//   }, []);


//   return (
//       <>
//          <table ref={tableRef} id="productsTable" className="table table-bordered table-hover table-product" style={{ width: '100%' }}>
//         <thead>
//           <tr>
//             <th>Sr No</th>
//             <th>Date</th>
//             <th>CMS ID</th>
//             <th>Name</th>
//             <th>Email Id</th>
//             <th>Phone</th>
//             <th>Address</th>
            
//           </tr>
//         </thead>
    
//       </table>
//       </>
//   );
// }

// export default Retailers;